import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';

import reducers from 'reducers';

export let store = null;

export const init = (additionalMiddleware = [], rootReducer = reducers) => {
  const middleware = getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: {
      // Ignore these action types
      ignoredActions: ['@@router/LOCATION_CHANGE', 'update-user-error'],
      // Ignore these field paths in all actions
      ignoredActionPaths: [],
      // Ignore these paths in the state
      ignoredPaths: ['routing', 'user.error'],
    },
  });

  if (additionalMiddleware.length > 0) {
    middleware.push(...additionalMiddleware);
  }

  store = configureStore({
    reducer: rootReducer,
    middleware,
  });

  return store;
};
